

export class debuggerScreenSize
{   
    private parent:PIXI.Container;
    private texts:Array<PIXI.Text>;

    constructor(parent:PIXI.Container)
    {
        this.parent= new PIXI.Container();
        parent.addChild(this.parent);

        let textStyle=new PIXI.TextStyle({
            align: "center",
            dropShadowAngle: 0.9,
            dropShadowBlur: 20,
            dropShadowColor: "#ff5c5c",
            dropShadowDistance: 0,
            fill: "white",
            fillGradientStops: [
                0,
                0.5,
                1
            ],
            fontFamily: "Tahoma",
            fontSize: 40,
            fontWeight: "bolder",
            lineHeight: 25,
            strokeThickness: 5,
            trim: true
        });
        let lengthArray=20;
        this.texts=[];
        for (let index = 0; index < lengthArray; index++) {
            this.texts[index]=new PIXI.Text(" ",textStyle);
            this.texts[index].y=index*(40);
            this.texts[index].anchor.set(0);
            this.parent.addChild(  this.texts[index]);

        }
     
    }


    public updateSize()
    {
        this.texts[0].text="window.innerHeight:"+window.innerHeight;
        this.texts[1].text="window.outerHeight:"+window.outerHeight;
        this.texts[2].text=" document.documentElement.clientHeight:"+ document.documentElement.clientHeight;
        this.texts[3].text="document.documentElement.offsetHeight: "+ document.documentElement.offsetHeight;
        this.texts[4].text="document.documentElement.scrollHeight: "+ document.documentElement.scrollHeight;
        var body = document.body;
        var html = document.documentElement;
        this.texts[5].text="body.scrollHeight: "+ body.scrollHeight;
        this.texts[6].text="body.offsetHeight: "+ body.offsetHeight;
        this.texts[7].text="body.offsetHeight: "+ body.scrollHeight;
        this.texts[8].text="html.clientHeight: "+ html.clientHeight;
        this.texts[9].text="html.scrollHeight: "+ html.scrollHeight;
        this.texts[10].text="html.offsetHeight: "+ html.offsetHeight;
        this.texts[11].text="screen.height: "+ screen.height;
        this.texts[12].text="screen.availHeight: "+  screen.availHeight;
        this.texts[13].text="screen.availWidth: "+  screen.availWidth;
        let condition1=(window.innerHeight==394 && screen.availWidth == 414);
        let condition2=(window.innerHeight == screen.availWidth);
        this.texts[14].text="IPHONE CHECK CONDITIONS: C1:CHROME", condition1,"  C2 SAFARI", condition2;
        this.texts[15].text=(window.innerHeight,"==394 and ", screen.availWidth ,"== 414 ,or  ",window.innerHeight ,"==", screen.availWidth+"");

        this.texts[16].text=(window.innerHeight,"==394 and "+ screen.availWidth ,"== 414 ,or  ",window.innerHeight ,"==", screen.availWidth+"");

        // var w = window.innerWidth
        // || document.documentElement.clientWidth
        // || document.body.clientWidth;

        var h = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;

        this.texts[17].text="x: "+ h;
       
    
        
   
    }
}
